import React from 'react';

import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import OptionRadioButton from '@/components/atoms/OptionRadioButton/OptionRadioButton';
import TitleSubtitle from '@/components/atoms/TitleSubtitle/TitleSubtitle';
import { Form, DepartmentRouting } from '@/modules/departments/models';

interface Props {
  control: Control<Form>;
  department_id?: string;
  disabled?: boolean;
}
const RoutingSelect = ({ control, department_id = '', disabled }: Props) => {
  const { t } = useTranslation();
  const options = [
    {
      value: DepartmentRouting.BALANCED,
      label: (
        <TitleSubtitle
          noGutters
          title={t('departments.mode.balanced')}
          subtitle={t('departments.mode.balanced_description')}
        />
      ),
      id: `${department_id}-${2}`,
    },
    {
      value: DepartmentRouting.ROUND_ROBIN,
      label: (
        <TitleSubtitle
          noGutters
          title={t('departments.mode.round_robin')}
          subtitle={t('departments.mode.round_robin_description')}
        />
      ),
      id: `${department_id}-${0}`,
    },
    {
      value: DepartmentRouting.MANUAL,
      label: (
        <TitleSubtitle
          noGutters
          title={t('departments.mode.manual')}
          subtitle={t('departments.mode.manual_description')}
        />
      ),
      id: `${department_id}-${1}`,
    },
  ];
  return (
    <>
      <p className="mb-2 text-sm leading-5 font-medium text-muted-foreground">
        {t('departments.assignment_mode')}
      </p>

      <div className="flex flex-col gap-4 pb-8">
        <Controller
          render={({ field: { onChange, value } }) => {
            return (
              <>
                {options.map((option) => {
                  return (
                    <OptionRadioButton
                      key={`${department_id}-${option.value}`}
                      option={{ value: option.value, label: option.label, id: option.id }}
                      isSelected={option.value === value}
                      disabled={disabled}
                      onChange={onChange}
                    />
                  );
                })}
              </>
            );
          }}
          name="routing"
          control={control}
        />
      </div>
    </>
  );
};

export default RoutingSelect;
